/**
 * Servicio que se encarga del manejo de las peticiones sobre las
 * acciones "Crear, Modificar y Eliminar" los estados que se manejan en las PQR.
 * JMM-2018-07-12
 */
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ConfigService } from '../../servicios/config/config.service';
import { KeyService } from '../../servicios/key.service';

@Injectable()
export class EstadopqrService {

  public tiposervicios : any[] = [];
  PATH = new ConfigService().obtenerPath();

  constructor(
    private http  : Http,
    private _key  : KeyService
  ) {}

  /**
   * Obtener listado de registros
   * JMM-2018-07-12
   */
  getEstadopqr()
  {
    let url = this.PATH + '/api/admin/estadopqr';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getEstadopqr()

  getEstadopqrTodos()
  {
    let url = this.PATH + '/api/admin/estadopqrTodos';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getEstadopqr()

    /**
   * Obtener listado de registros
   * JMM-2018-07-12
   */
  getEstadopqrservicio()
  {
    let url = this.PATH + '/api/admin/estadoservicio';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getEstadopqr()

  /**
   * Obtener un registro por id para editar
   * JMM-2018-07-12
   */
  getRegEstadopqr(id:any)
  {
    let url = this.PATH + '/api/admin/estadopqr/'+id+'/edit';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getRegEstadopqr(id:any)

  /**
   * Guardar registro
   * JMM-2018-07-12
   */
  setEstadopqr(estadopqr:any)
  {
    let url = this.PATH + '/api/admin/estadopqr';
    return this.http.post(url, estadopqr, {headers:this._key.head()}).map(resp => resp.json());
  }// .setEstadopqr(estadopqr:any)

  /**
   * Editar registro
   * JMM-2018-07-12
   */
  editEstadopqr(estadopqr:any)
  {
    let url = this.PATH+'/api/admin/estadopqr/'+estadopqr.id;
    return this.http.put(url, estadopqr, {headers:this._key.head()}).map( resp => resp.json());
  }// .editEstadopqr(mediosoporte:any)

  /**
   * Eliminar registro
   * JMM-2018-07-12
   */
  destroyEstadopqr(id:any)
  {
    let url = this.PATH + '/api/admin/estadopqr/'+id;
    return this.http.delete(url, {headers:this._key.head()}).map( resp => resp.json());
  }// .destroyEstadopqr(id:any)

  obtenerFiltro(info)
  {
    let id = info.id != '' ? info.id : null;
    let nombre = info.nombre  != '' ? info.nombre    : null;

    let url = this.PATH + '/api/admin/obtenerfiltroestadopqr/'+id+'/'+nombre;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

    /**
   * Reabrir Incidencia desde el perfil cliete
   * CAAA-2019-09-19
   */
  reabrirIncCliente(pqrid)
  {
    let url = this.PATH + '/api/admin/reabrirIncCliente/'+pqrid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .reabrirIncCliente()


   /**
   *consulta
   * CAAA-2019-09-19
   */
  consultartransicionestado()
  {
    let url = this.PATH + '/api/admin/consultartransicionestado';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .consulta()

  /**
   *consulta
   * CAAA-2019-09-19
   */
  submittransicionestado(data)
  {
    let url = this.PATH + '/api/admin/submittransicionestado';
    return this.http.post(url,data, {headers:this._key.head()}).map(resp => resp.json());
  }// .consulta()

  /**
   * PERMITE PERMITE CONSULTAR LA LA TRANSACUION DEL ESTADO SEGUNE EL ESTADO EN EL QUE SE ENCUENTRE LA INCIDENCIA
   * CAAA-2019-09-19
  */
  gettransicionestado(estadopqrid)
  {
    let url = this.PATH + '/api/admin/gettransicionestado/'+estadopqrid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .gettransicionestado()

  validaestadopqr(estadopqrid){
    let url = this.PATH + '/api/admin/validaestadopqr/'+estadopqrid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .validaestadopqr()

  estadoservicio(){
    let url = this.PATH + '/api/admin/estadoservicio';
    return this.http.get(url,{headers:this._key.head()}).map(resp => resp.json());
  }// .estadoservicio()

  obtenerTodosEstado(){
    let url = this.PATH + '/api/admin/obtenerTodosEstado';
    return this.http.get(url,{headers:this._key.head()}).map(resp => resp.json());
  }// .obtenerTodosEstado()

  estadopqrcliente(terceroid){
    let url = this.PATH + '/api/admin/estadopqrcliente/'+terceroid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .estadopqrcliente()

  estadopqrEquipo(terceroid,equipoid){
    let url = this.PATH + '/api/admin/estadopqrEquipo/'+terceroid+'/'+equipoid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .estadopqrEquipo()

  //10-02-2023 Alexander Arenas
  obtenerEstadoAnularPorListaChequeo() {
    const url = `${this.PATH}/api/admin/estadopqranularporlistachequeo`;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }
}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/pqr/estadopqr.service.ts